import { useState, useEffect, useContext } from "react";
import {
  getVolunteerList,
  updateVolunteersStatus,
} from "../core/api";
import { formatDate, isValidDate } from "../utils/date";
import { CoordinatorContext } from "../context/CoordinatorContext";
import { KHIDMAT_LIST, VENUE_LIST } from "../core/constant";

const Attendance = () => {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { coordinator } = useContext(CoordinatorContext);
  const [selectedVolunteers, setSelectedVolunteers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]); // Format: YYYY-MM-DD
  const [selectedVenue, setSelectedVenue] = useState(coordinator?.venueId || "ALL");
  const [selectedService, setSelectedService] = useState(coordinator?.serviceId || "ALL");
  const [selectedStatus, setSelectedStatus] = useState('ALL');
  const [filteredVolunteers, setFilteredVolunteers] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    confirmed: 0,
    rejected: 0,
    absent: 0,
    present: 0,
    pending: 0,
  });

  const refreshVolunteers = (volunteerList) => {
    setVolunteers(volunteerList);
    processAttendanceData(volunteerList);
    setFilteredVolunteers(volunteerList);
    setSelectedVolunteers([]); // Uncheck all
    setSelectAll(false);
  }

  const fetchVolunteers = async (date, venue, service) => {
    if (date && venue && service) {
      setLoading(true);
      const volunteersResponse = await getVolunteerList(date, venue, service);
      console.log("volunteersResponse", volunteersResponse);
      if (volunteersResponse.success) {
        refreshVolunteers(volunteersResponse.volunteers);
      } else {
        alert("Volunteers details not found");
      }

    }
    setLoading(false);
  };

  const processAttendanceData = (data) => {
    let total = 0;
    let statusCount = { present: 0, absent: 0, pending: 0, confirmed: 0, rejected: 0 };

    data.forEach((volunteer) => {
      total++;
      if (volunteer.status === "PRESENT") statusCount.present++;
      else if (volunteer.status === "ABSENT") statusCount.absent++;
      else if (volunteer.status === "CONFIRMED") statusCount.confirmed++;
      else if (volunteer.status === "REJECTED") statusCount.rejected++;
      else statusCount.pending++;
    });

    setStatusCounts({
      total,
      ...statusCount,
    });
  };


  useEffect(() => {
    if (coordinator && coordinator?.venueId && coordinator?.serviceId) {
      setSelectedVenue(coordinator?.venueId);
      setSelectedService(coordinator?.serviceId);
    }
  }, [coordinator]);

  useEffect(() => {
    // check date isvalid or not 
    if (selectedDate && isValidDate(selectedDate)) {
      console.log('selectedDate', selectedDate);
      console.log('selectedVenue', selectedVenue);
      console.log('selectedService', selectedService);
      // console.log('coordinator', coordinator);

      fetchVolunteers(selectedDate, selectedVenue, selectedService);
    } else {
      setLoading(false);
    }
  }, [selectedDate, selectedVenue, selectedService]);

  useEffect(() => {
    if (selectedStatus === 'ALL') {
      setFilteredVolunteers(volunteers);
    }
    else {
      const filter = volunteers.filter(v => v.status === selectedStatus);
      setFilteredVolunteers(filter);
    }
    setSelectedVolunteers([]); // Uncheck all
    setSelectAll(false);
  }, [selectedStatus]);

  const markAttendance = async (status) => {
    if (selectedVolunteers.length === 0) {
      alert("No volunteers selected!");
      return;
    } else {
      console.log("selectedVolunteers", selectedVolunteers);
      setLoading(true);
      if (selectedVenue && selectedVenue !== 'ALL' && selectedService && selectedService !== 'ALL') {
        const updateResponse = await updateVolunteersStatus(
          selectedVenue,
          selectedService,
          selectedDate,
          selectedVolunteers.join(","),
          status
        );
        if (updateResponse.success) {
          refreshVolunteers(updateResponse.volunteers);
        }
      }
      else {
        alert('kindly select specific venue and khidmat to update status of KGs');
      }

      setLoading(false);

    }
  };

  // Handle individual selection
  const handleSelectVolunteer = (id) => {
    setSelectedVolunteers((prev) =>
      prev.includes(id) ? prev.filter((volId) => volId !== id) : [...prev, id]
    );
  };

  // Handle "Select All"
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedVolunteers([]); // Uncheck all
    } else {
      setSelectedVolunteers(volunteers.map((vol) => vol.id)); // Select all
    }
    setSelectAll(!selectAll);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "ABSENT":
        return "bg-red-500 text-white";
      case "REJECTED":
        return "bg-red-500 text-white";
      case "PRESENT":
        return "bg-green-500 text-white";
      case "CONFIRMED":
        return "bg-orange-500 text-white";
      default:
        return "bg-gray-400 text-white";
    }
  };

  const getDisabledClass = (type) => {
    switch (type) {
      case "venue":
        return loading ||
          (coordinator?.isCoordinator && !coordinator?.isMultitasker) ||
          (coordinator?.isVenueHead && !coordinator?.isMultitasker)
          ? "disabled:bg-gray-200"
          : "";
      case "service":
        return loading ||
          (coordinator?.isCoordinator && !coordinator?.isMultitasker && !coordinator?.secondaryKhidmat?.length) ||
          (coordinator?.isMufasihCoordinator && !coordinator?.isMultitasker)
          ? "disabled:bg-gray-200"
          : "";

      case "date":
        return loading ||
          (coordinator?.isCoordinator && !coordinator?.isMultitasker)
          ? "disabled:bg-gray-200"
          : "";

      default:
        return;
    }
  };

  const checkAttendanceAccess = (coordinator) => {
    if (!coordinator) return false;
    return ((coordinator?.isCoordinator && coordinator?.venueId === selectedVenue &&
      (coordinator?.serviceId === selectedService || coordinator?.secondaryKhidmat?.includes(selectedService))) || (
        coordinator?.isMufasihCoordinator
      ));
  };
  return (
    <div className="">
      <h1 className="text-2xl flex justify-between items-center font-bold mb-4">
        {`Attendance: ${formatDate(selectedDate)}`}

      </h1>
      <div className="flex flex-col sm:flex-row gap-2 mb-4">
        {/* Venue Dropdown */}
        <div className="flex-1 flex flex-row items-center sm:flex-col sm:items-start gap-1">
          <label htmlFor="venue" className="block text-sm font-semibold">Select Venue:</label>
          <select
            id="venue"
            disabled={!!getDisabledClass('venue')}
            value={selectedVenue}
            onChange={(e) => setSelectedVenue(e.target.value)}
            className={`w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${getDisabledClass('venue')}`}
          >
            <option value="">Select Venue</option>
            <option value="ALL">All Venues</option>
            {VENUE_LIST.map((venue) => (
              <option key={venue.id} value={venue.id}>{venue.name}</option>
            ))}
          </select>
        </div>

        {/* Service Dropdown */}
        <div className="flex-1 flex flex-row items-center sm:flex-col sm:items-start gap-1">
          <label htmlFor="service" className="block text-sm font-semibold">Khidmat:</label>
          <select
            id="service"
            disabled={!!getDisabledClass('service')}
            value={selectedService}
            onChange={(e) => setSelectedService(e.target.value)}
            className={`w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${getDisabledClass('service')}`}
          >
            <option value="">Select Khidmat</option>
            <option value="ALL" className="bold"><strong>All Khidmats</strong></option>
            {KHIDMAT_LIST.map((service) => (
              <option key={service.id} value={service.id}>{service.name}</option>
            ))}
          </select>
        </div>

        {/* Date Picker */}
        <div className="flex-1 flex flex-row items-center sm:flex-col sm:items-start gap-1">
          <label htmlFor="date" className="block text-sm font-semibold">Select Date:</label>
          <input
            type="date"
            id="date"
            disabled={!!getDisabledClass('date')}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className={`w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${getDisabledClass('date')}`}
          // min={new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split("T")[0]}
          //max={new Date(new Date().setDate(new Date().getDate() + 10)).toISOString().split("T")[0]}
          />
        </div>
        {/* add status dropdown */}
        <div className="flex-1 flex flex-row items-center sm:flex-col sm:items-start gap-1">
          <label htmlFor="status" className="block text-sm font-semibold">Status:</label>
          <select
            id="status"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className={`w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500`}
          >
            <option value="ALL" className="bold"><strong>All Status</strong></option>
            <option value="PENDING">Pending</option>
            <option value="CONFIRMED">Confirmed</option>
            <option value="REJECTED">Rejected</option>
            <option value="PRESENT">Present</option>
            <option value="ABSENT">Absent</option>
          </select>
        </div>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="overflow-x-auto bg-white shadow-md rounded-lg">
            <div className="bg-white p-3 rounded-md flex flex-wrap items-center justify-between text-sm">
              <div className="font-semibold">
                Total: <span className="text-blue-500">{statusCounts.total}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                <div className={`px-2 py-1 rounded-md font-semibold ${getStatusClass('PRESENT')}`}>
                  Present: {statusCounts.present}
                </div>
                <div className={`px-2 py-1 rounded-md font-semibold ${getStatusClass('ABSENT')}`}>
                  Absent: {statusCounts.absent}
                </div>
                <div className={`px-2 py-1 rounded-md font-semibold ${getStatusClass('CONFIRMED')}`}>
                  Confirmed: {statusCounts.confirmed}
                </div>
                <div className={`px-2 py-1 rounded-md font-semibold ${getStatusClass('REJECTED')}`}>
                  Rejected: {statusCounts.rejected}
                </div>
                <div className={`px-2 py-1 rounded-md font-semibold ${getStatusClass('PENDING')}`}>
                  Pending: {statusCounts.pending}
                </div>
              </div>
            </div>
            <div className="max-h-[600px] overflow-y-auto border rounded-lg">
              <table className="w-full border-collapse">
                <thead className="sticky top-0">
                  <tr className="bg-gray-200">
                    <th className="p-3 border">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 border">Name</th>
                    <th className="p-3 border">ITS Number</th>
                    <th className="p-3 border">Age</th>
                    <th className="p-3 border">Phone Number</th>
                    <th className="p-3 border">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVolunteers?.length ? filteredVolunteers.map((volunteer) => (
                    <tr key={volunteer.id} className="text-center border-b">
                      <td className="p-3 border">
                        <input
                          type="checkbox"
                          checked={selectedVolunteers.includes(volunteer.id)}
                          onChange={() => handleSelectVolunteer(volunteer.id)}
                        />
                      </td>
                      <td className="p-3 border">{volunteer.name}</td>
                      <td className="p-3 border">{volunteer.ITSNo}</td>
                      <td className="p-3 border">{volunteer.age || 'N/A'}</td>
                      <td className="p-3 border"><a href={`tel:+${volunteer.phone}`} className="text-blue-500 underline">
                        {`+${volunteer.phone}`}
                      </a></td>
                      <td className="p-3 border">
                        <span className={`px-2 py-1 rounded ${getStatusClass(volunteer.status)}`}>
                          {volunteer.status || "Pending"}
                        </span>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="4" className="p-3 border text-center">
                        No volunteers found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {(checkAttendanceAccess(coordinator)) && (
            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <button
                onClick={() => markAttendance("PRESENT")}
                className="flex-1 bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition"
              >
                ✅ Mark Selected as Present
              </button>
              <button
                onClick={() => markAttendance("ABSENT")}
                className="flex-1 bg-red-500 text-white py-3 rounded-lg hover:bg-red-600 transition"
              >
                ❌ Mark Selected as Absent
              </button>
            </div>
          )}
          {coordinator?.isMufasihCoordinator && (
            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <button
                onClick={() => markAttendance("CONFIRMED")}
                className="flex-1 bg-orange-500 text-white py-3 rounded-lg hover:bg-green-600 transition"
              >
                Mark Selected as Confirmed
              </button>
              <button
                onClick={() => markAttendance("REJECTED")}
                className="flex-1 bg-red-500 text-white py-3 rounded-lg hover:bg-red-600 transition"
              >
                ❌ Mark Selected as Rejected
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Attendance;
